module.exports = __webpack_public_path__ + "static/img/5.8ce17d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/5.png
// module id = +GeD
// module chunks = 1